import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const subBannerFade = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

export const SubBannerContainer = styled.div<{ bgImg: string }>`
	padding: 0;
	min-height: 54rem;
	height: 100%;
	color: #fff;
	position: relative;
	background:
		linear-gradient(90deg, rgba(10, 13, 17, 0.8) 0%, rgba(10, 13, 17, 0.3) 100%),
		url(${(props) => props.bgImg}) lightgray 0px -278.125px / 100% 199.306% no-repeat;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	@media screen and (max-width: 900px) {
		min-height: 34rem;
	}
`;
export const SubContentBanner = styled.div``;
export const TextBoxWrapper = styled.div`
	position: absolute;
	top: 50%;
	left: 0;
	width: 100%;
	transform: translateY(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.8rem;
	animation: ${subBannerFade} ${(props) => props.theme.motion.duration.slower} ${(props) => props.theme.motion.easing.decelerate}
		both;
	.sub_title {
		text-align: center;
		font-size: ${(props) => props.theme.fontSize.size4xl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: 130%;
		letter-spacing: -0.6px;
		color: #dee2e6;
		@media screen and (max-width: 900px) {
			font-size: ${(props) => props.theme.fontSize.sizeXl};
		}
	}
	.title {
		font-size: 5.2rem;
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
		@media screen and (max-width: 900px) {
			font-size: 4.2rem;
		}
	}
`;
